import { render, staticRenderFns } from "./versionOld.vue?vue&type=template&id=42e553b8&scoped=true&"
import script from "./versionOld.vue?vue&type=script&lang=js&"
export * from "./versionOld.vue?vue&type=script&lang=js&"
import style0 from "./versionOld.vue?vue&type=style&index=0&id=42e553b8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e553b8",
  null
  
)

export default component.exports